<div data-testid="generic-pick-class-modal" class="kh-medium-title-text p-kh-4">
  {{ 'GENERIC_PICK_CLASS_MODAL.PLEASE_SELECT_YOUR_CLASS' | translate }}

  <kh-common-dropdown
    data-testid="class-dropdown"
    [(ngModel)]="selectedClassId"
    (ngModelChange)="selectClass($event)"
    [ngModelOptions]="{ standalone: true }"
    [items]="classes"
    arrowColor="kh-grey-accessible"
    [placeholder]="'GENERIC_PICK_CLASS_MODAL.SELECT_CLASS' | translate"
    [getName]="getClassName"
    [getValue]="getClassId">
  </kh-common-dropdown>
</div>